import { DocumentMetadataPropertyReferenceEnum, DocumentMetadataPropertyTypeEnum, } from 'shared/domains/apollo/generated/types';
import { booleanFormatter, categoryFormatter, dateFormatter, documentStatusFormatter, entityTypeFormatter, esigningStatusFormatter, marketFormatter, metadataValueFormatter, stringFormatter, userFormatter, } from './formatters';
import { getMetadataProperty } from '../metadataProperties';
function allowedValueLabel(allowedValues, value) {
    if (typeof value !== 'string' || !(allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.length)) {
        return stringFormatter(value);
    }
    const match = allowedValues.find((allowedValue) => allowedValue.value === value);
    if (match) {
        return match.text;
    }
    const grouped = allowedValues
        .flatMap((allowedValue) => allowedValue.groupValues || [])
        .find((groupValue) => groupValue.value === value);
    return (grouped === null || grouped === void 0 ? void 0 : grouped.text) || stringFormatter(value);
}
function formatByPropertyType(property, value) {
    switch (property.type) {
        case DocumentMetadataPropertyTypeEnum.Boolean:
            return booleanFormatter(value);
        case DocumentMetadataPropertyTypeEnum.Date:
        case DocumentMetadataPropertyTypeEnum.Datetime:
            return dateFormatter(value);
        case DocumentMetadataPropertyTypeEnum.List:
            return allowedValueLabel(property.allowedValues, value);
        case DocumentMetadataPropertyTypeEnum.Reference:
            if (property.reference === DocumentMetadataPropertyReferenceEnum.User) {
                return userFormatter(value);
            }
            return stringFormatter(value);
        case DocumentMetadataPropertyTypeEnum.Number:
        case DocumentMetadataPropertyTypeEnum.SimpleText:
        case DocumentMetadataPropertyTypeEnum.MultiLineText:
        default:
            return stringFormatter(value);
    }
}
export function getFieldDisplayValue(field, value) {
    if (!field || !value) {
        return stringFormatter(value);
    }
    const property = getMetadataProperty(field);
    if (property) {
        return formatByPropertyType(property, value);
    }
    switch (field) {
        case 'createdAt':
        case 'metadataDocumentDateSigned':
        case 'updatedAt':
            return dateFormatter(value);
        case 'categoryId':
            return categoryFormatter(value);
        case 'createdByUserId':
            return userFormatter(value);
        case 'entityType':
            return entityTypeFormatter(value);
        case 'isPlGenerated':
        case 'metadataDocumentIsSharedExternally':
            return booleanFormatter(value);
        case 'marketCode':
            return marketFormatter(value);
        case 'metadataDocumentStatus':
            return documentStatusFormatter(value);
        case 'metadataDocumentEsigningStatus':
            return esigningStatusFormatter(value);
        case 'metadataDocumentType':
            return metadataValueFormatter('DocumentType', value);
        default:
            return stringFormatter(value);
    }
}
